"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AidKitToken = exports.startAidKitCryptoPromise = void 0;
var fernet = __importStar(require("fernet"));
var crypto_1 = __importDefault(require("crypto"));
var secrets_1 = require("./secrets");
var kms = __importStar(require("@aws-sdk/client-kms"));
// TODO(luke): remove if we can get a way to import the one from aidkit/lib/common/handler.ts
function getKMSClient() {
    return new kms.KMSClient(process.env.NODE_ENV === 'development' ? { endpoint: 'http://127.0.0.1:5555' } : {});
}
function startAidKitCryptoPromise() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, (0, secrets_1.getGlobalConfigs)('HASH_KEY', 'ENCRYPTION_KEY', 'IMGPROXY_KEY', 'IMGPROXY_SALT', 'IMGPROXY_SECRET', 'REALTIME_BARCODE_SCANNING_QUEUE_URL').then(function (res) {
                    if (!res.HASH_KEY || !res.ENCRYPTION_KEY) {
                        return null;
                    }
                    return new AidKitToken(res.HASH_KEY, res.ENCRYPTION_KEY, res.IMGPROXY_KEY, res.IMGPROXY_SALT, res.IMGPROXY_SECRET, res.REALTIME_BARCODE_SCANNING_QUEUE_URL, getKMSClient());
                })];
        });
    });
}
exports.startAidKitCryptoPromise = startAidKitCryptoPromise;
var AidKitToken = /** @class */ (function () {
    function AidKitToken(hashKey, encryptionKey, imgproxyKey, imgproxySalt, imgproxySecret, rbsQueueUrl, kms) {
        this.hashKey = hashKey;
        this.encryptionKey = encryptionKey;
        this.imgproxyKey = imgproxyKey;
        this.imgproxySalt = imgproxySalt;
        this.imgproxySecret = imgproxySecret;
        this.rbsQueueUrl = rbsQueueUrl;
        this.kms = kms;
        if (!this.hashKey || !this.encryptionKey) {
            throw new Error('Cannot create token without hashKey and encryptionKey');
        }
        this.encryptionKey = encryptionKey;
        this.hashKey = hashKey;
        this.imgproxyKey = imgproxyKey;
        this.imgproxySalt = imgproxySalt;
        this.imgproxySecret = imgproxySecret;
        // Realtime barcode scanning queue url
        this.rbsQueueUrl = rbsQueueUrl;
    }
    AidKitToken.prototype.getImageHandlerKeys = function () {
        return {
            IMGPROXY_KEY: this.imgproxyKey,
            IMGPROXY_SALT: this.imgproxySalt,
            IMGPROXY_SECRET: this.imgproxySecret
        };
    };
    AidKitToken.prototype.decrypt = function (keyId, text) {
        return __awaiter(this, void 0, void 0, function () {
            var result, decoder, decrypted, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.kms) {
                            return [2 /*return*/, { success: false, error: new Error("KMS client not initialized"), text: text }];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.kms.send(new kms.DecryptCommand({
                                KeyId: keyId,
                                CiphertextBlob: Buffer.from(text, 'base64'),
                                EncryptionAlgorithm: 'RSAES_OAEP_SHA_256'
                            }))];
                    case 2:
                        result = _a.sent();
                        decoder = new TextDecoder('utf-8');
                        decrypted = decoder.decode(result.Plaintext);
                        return [2 /*return*/, { success: true, text: decrypted }];
                    case 3:
                        e_1 = _a.sent();
                        console.error("Error decrypting: ", e_1);
                        return [2 /*return*/, { success: false, error: e_1, text: text }];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AidKitToken.prototype.decode = function (string) {
        var secret = new fernet.Secret(this.encryptionKey);
        try {
            var token = new fernet.Token({ secret: secret, token: string, ttl: 0 });
            var decoded = token.decode();
            return decoded;
        }
        catch (e) {
            console.log("Error decoding: ", (string === null || string === void 0 ? void 0 : string.includes('gAA')) ? string : 'userdata already decoded');
            return string;
        }
    };
    AidKitToken.prototype.encode = function (string) {
        // Check if string is already encoded:
        var decoded = this.decode(string);
        var secret = new fernet.Secret(this.encryptionKey);
        var token = new fernet.Token({ secret: secret });
        return token.encode(decoded);
    };
    AidKitToken.prototype.hash = function (string) {
        // Check if string is already encoded:
        var decoded = this.decode(string);
        return crypto_1.default.createHmac('sha256', this.hashKey).update(decoded).digest('hex');
    };
    AidKitToken.prototype.hashNoDecode = function (string) {
        return crypto_1.default.createHmac('sha256', this.hashKey).update(string).digest('hex');
    };
    return AidKitToken;
}());
exports.AidKitToken = AidKitToken;
